import React, { useEffect, useState } from "react";
import { Button, Form, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import superagent from "superagent";
import { AUTH_API_URL } from "../../../constants";
import { isAuthAdmin, isLicenseAdmin } from "../../../utils";
import useAdminUser from "../../../hooks/useAdminUser";

const UserSecurity = ({
  profile,
  refreshUser,
}) => {

  const adminUser = useAdminUser();

  const [password, setPassword] = useState("");
  const [visible, setVisibility] = useState(false);
  const [flashLink, setFlashLink] = useState(false);
  const [pwLink, setPwLink] = useState("");

  const onSubmit = () => {
    superagent
      .patch(`${AUTH_API_URL}/users/${profile._id}/password`)
      .send({ password })
      .withCredentials()
      .then(() => {
        refreshUser();
        setPassword("");
      })
      .catch((err) => {
        const errorMessage =
          (err.response && err.response.body && err.response.body.error) ||
          "There was a problem updating the user's password. Please try again.";
        window.alert(errorMessage);
        setPassword("");
      });
  };

  const onChange = (e, data) => {
    e.preventDefault();
    setPassword(data.value);
  };

  const toggleVisibility = () => setVisibility(!visible);

  const onCancel = () => setPassword("");
  const onCopyLink = async () => {
    try {
      if (!pwLink || !pwLink.length) return window.alert("No password reset link to copy");
      await navigator.clipboard.writeText(pwLink);
      setFlashLink(true);
    } catch (err) {
      window.alert("Failed to copy password reset link");
    }
  };

  const onRequestPWLink = async () => {
    if (pwLink && pwLink.length) return;
    try {
      const res = await superagent
        .get(`${AUTH_API_URL}/users/${profile._id}/password/resetlink`)
        .withCredentials();

      setPwLink(res.body.url);
    } catch (err) {
      const errorMessage = (err.response && err.response.body && err.response.body.error) || "There was a problem retrieving the password reset link. Please refresh and try again.";
      window.alert(errorMessage);
    }
  }

  useEffect(() => {
    const to = flashLink ? setTimeout(() => setFlashLink(false), 1000) : undefined;
    return () => clearTimeout(to);
  }, [flashLink]);

  return (
    <div>
      <Form size='tiny' onSubmit={ (e) => e.preventDefault() } style={{ marginBottom: "3rem" }} >
        {
          isAuthAdmin(adminUser) || isLicenseAdmin(adminUser) ? (
            <Form.Input
              action={
                pwLink && pwLink.length ? {
                  labelPosition: 'right',
                  icon: 'copy',
                  color: 'blue',
                  content: flashLink ? 'Copied!' : 'Copy',
                  size: 'tiny',
                  onClick: onCopyLink
                } : {
                  labelPosition: 'right',
                  icon: 'refresh',
                  content: 'Get Reset Link',
                  size: 'tiny',
                  onClick: onRequestPWLink
                }
              }
              label="Password Reset Link"
              value={ pwLink || '' }
              fluid
              readOnly
            />
          ) : null
        }
      </Form>
      <Form size='tiny' onSubmit={ onSubmit } >
        {
          isAuthAdmin(adminUser) ? (
            <React.Fragment>
              <Form.Input
                icon={ <Icon name={ visible ? 'lock' : 'eye' } circular link onClick={ toggleVisibility } /> }
                width={ 16 }
                label='Password'
                name='password'
                type={ visible ? 'text' : 'password' }
                autoComplete='new-password'
                placeholder='New Password'
                value={ password }
                onChange={ onChange }
              />
              <Button.Group>
                <Button disabled={ !password.length } onClick={ onCancel }>Cancel</Button>
                <Button.Or />
                <Button positive={ !!password.length } disabled={ !password.length } type="submit">Save</Button>
              </Button.Group>
            </React.Fragment>
          ) : null
        }
        {
          !isAuthAdmin(adminUser) && !isLicenseAdmin(adminUser) ? (
            <div>You do not have the right permissions to access more of the user&apos;s security settings.</div>
          ) : null
        }
      </Form>
    </div>
  );
};

UserSecurity.propTypes = {
  profile: PropTypes.object.isRequired,
  refreshUser: PropTypes.func.isRequired
}

export default UserSecurity;



// WEBPACK FOOTER //
// ./webAdmin/components/users/user/security.js